import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import STEP_TYPES from 'constants/stepper';

const toFormattedPosition = (position) => position + 1;

const getStepLabelType = (position, activeStepPosition) => {
  if (activeStepPosition > position) {
    return STEP_TYPES.COMPLETED;
  }

  if (activeStepPosition === position) {
    return STEP_TYPES.CURRENT;
  }

  return STEP_TYPES.NOT_STARTED;
};

const Stepper = forwardRef(
  ({ activeStep = 1, render: renderFn, steps, ...rest }, ref) => (
    <div ref={ref} {...rest}>
      {steps.map((step) => {
        const position = toFormattedPosition(steps.indexOf(step));
        const type = getStepLabelType(position, activeStep);

        return renderFn({ step, control: { key: step, position, type } });
      })}
    </div>
  )
);

Stepper.displayName = 'Stepper';

Stepper.propTypes = {
  activeStep: PropTypes.number,
  render: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Stepper;
